import React from "react";
import CalculatorContext from "./CalculatorContext";

export default function ProgressBar({ current, total }: { current: number; total: number }) {
  const percent = (current / total) * 100;
  const { translation } = React.useContext(CalculatorContext);

  return (
    <div
      style={{
        position: "relative",
        width: "100%",
        height: "40px",
        background: "#e0d7f5",
        borderRadius: "0.3rem 2rem 2rem 0.3rem",
      }}
    >
      {" "}
      <div
        style={{
          width: percent === 100 ? "" : `${percent}%`,
          height: "100%",
          background: "#6a4fbb",
          borderRadius: "0.3rem 2rem 2rem 0.3rem",
          transition: "width 0.3s ease",
        }}
      ></div>
      <span
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          fontSize: "14px",
          fontWeight: "bold",
          color: "#fff",
        }}
      >
        {`${current}/${total}`}
      </span>
    </div>
  );
}
